import React, { useState } from 'react'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { useGBExperiment } from '@/experimentation'
import { Modal } from '@/molecules/Modal'
import { GroupTicketsFaq } from '@/views/TicketCheckoutViews/ShowtimesView/components/modals/GroupTicketsModal/GroupTicketsFaq'
import { ShopifyGroupTickets } from './ShopifyGroupTickets'

const TICKET_PRICE = 15.0

export type GroupTicketsModalTypes = 'tickets' | 'faq'

export interface GroupTicketsModalProps {
  open: boolean
  onClose: () => void
  groupTicketProductVariantId: string
  theatricalSlug: string
}

export const GroupTicketsModal = ({
  open,
  onClose,
  theatricalSlug,
  groupTicketProductVariantId,
}: GroupTicketsModalProps) => {
  const [modalType, setModalType] = useState<GroupTicketsModalTypes>('tickets')
  const [groupTicketsExp, ready] = useGBExperiment('group-ticket-discounts-number-free', 'off')

  if (!ready) return null

  return (
    <Modal
      backgroundScreenColor="black"
      backgroundOverlayClassName="overflow-y-auto min-h-screen"
      className="z-[9999]"
      isOpen={open}
      transition="appear"
      panelClasses="!w-[calc(100%-2em)] md:w-full !max-w-[540px] overflow-y-auto !p-6 !pt-8 md:!px-10 md:!pb-8 shadow-light-3"
    >
      <div className="absolute right-6 top-6 cursor-pointer rounded-full bg-core-gray-300 p-2" onClick={onClose}>
        <CloseIcon color="core-gray-700" size={16} />
      </div>

      <div>
        {modalType === 'tickets' && (
          <ShopifyGroupTickets
            setModalType={setModalType}
            ticketPrice={TICKET_PRICE}
            theatricalSlug={theatricalSlug}
            groupTicketProductVariantId={groupTicketProductVariantId}
            groupTicketsExp={groupTicketsExp}
          />
        )}

        {modalType === 'faq' && <GroupTicketsFaq setModalType={setModalType} groupTicketsExp={groupTicketsExp} />}
      </div>
    </Modal>
  )
}
